import { SliderFilter } from 'shared/components/slider/SliderFilter';

export interface DistanceSliderStateProps {
    id: string;
    label: string;
    min: number;
    max: number;
    initialDistance?: number;
}

export interface DistanceSliderDispatchProps {
    distanceChange: (newDistance?: number) => void;
    onFilterChange: () => void;
}

export type DistanceSliderProps = DistanceSliderStateProps & DistanceSliderDispatchProps;

export const DistanceSlider = ({ id, label, min, max, initialDistance, distanceChange, onFilterChange }: DistanceSliderProps) => {
    const step = 50;
    const distanceWithStep = Math.round((initialDistance || max) / step) * step;

    const updateState = (value: number): void => {
        if (value !== max) {
            distanceChange(value);
        } else {
            distanceChange(undefined);
        }
        onFilterChange();
    };

    return (
        <SliderFilter
            id={`distanceSlider-${id}`}
            label={label}
            value={distanceWithStep}
            affix="m"
            min={min}
            max={max}
            step={step}
            renderValue={(num) => `${num} meter`}
            onChange={updateState}
        />
    );
};
